// extracted by mini-css-extract-plugin
export default {"BranchSaveNotification-description":"BranchSaveNotification-descriptioni1kwU5xgjfNT"};